import React, { useState } from 'react';
import './WaitingList.css'; // We'll create this CSS file

const WaitingList = () => {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  // Check if form is valid
  const isFormValid = name.trim().length > 0 && phone.trim().length > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/waitinglist/subscribe/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone, name }),
      });

      if (response.ok) {
        setMessage('🎉 Félicitations ! Vous avez rejoint l\'accès exclusif. Votre bonus de 20 Zaires vous attend au lancement !');
        setPhone('');
        setName('');
      } else {
        const error = await response.json();
        setMessage(error.message || 'Une erreur s\'est produite. Veuillez réessayer.');
      }
    } catch (error) {
      setMessage('Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="waiting-list-page">
      <div className="waiting-list-container">
        <div className="waiting-list-header">
          <div className="exclusive-badge">🎁 ACCÈS EXCLUSIF</div>
          <h1>Ne Manquez Pas l'Opportunité de l'Année !</h1>
          <p className="subtitle">Rejoignez les pionniers de Wennze et recevez <span className="highlight">20 Zaires GRATUITS</span> pour booster vos produits !</p>
          <div className="timer-section">
            <p className="urgency-text">⚡ Places Limitées - Inscrivez-vous Maintenant !</p>
          </div>
        </div>

        <div className="waiting-list-content">
          <div className="benefits-section">
            <h2 className="benefits-title">🚀 Pourquoi Rejoindre Maintenant ?</h2>
            <div className="features">
              <div className="feature">
                <div className="feature-icon">💰</div>
                <h3>20 Zaires de Bonus</h3>
                <p>Boostez vos produits GRATUITEMENT et touchez des milliers d'acheteurs dès le jour 1 !</p>
              </div>
              <div className="feature">
                <div className="feature-icon">👑</div>
                <h3>Statut VIP Exclusif</h3>
                <p>Accès prioritaire aux nouvelles fonctionnalités et support client premium à vie.</p>
              </div>
              <div className="feature">
                <div className="feature-icon">⚡</div>
                <h3>Avantage Premier Arrivé</h3>
                <p>Devenez vendeur star avant tout le monde - dominez votre marché local !</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🎯</div>
                <h3>Zéro Frais de Lancement</h3>
                <p>Pas de commissions pendant les 3 premiers mois - gardez 100% de vos profits !</p>
              </div>
            </div>
          </div>

          <div className="signup-form">
            <div className="form-header">
              <h2>🎁 Réclamez Vos 20 Zaires GRATUITS !</h2>
              <p className="form-subtitle">Inscrivez-vous en 10 secondes et faites partie de l'élite Wennze</p>
            </div>
            <div className="trust-indicators">
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Inscription 100% Gratuite</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Sans Engagement</span>
              </div>
              <div className="trust-item">
                <span className="trust-icon">✓</span>
                <span>Bonus Garanti</span>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Votre Nom Complet</label>
                <input
                  type="text"
                  placeholder="Ex: Jean Kabongo"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Numéro de Téléphone</label>
                <input
                  type="tel"
                  placeholder="Ex: +243 XXX XXX XXX"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  className="form-input"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting || !isFormValid}
                className="submit-btn"
              >
                {isSubmitting ? '⏳ Inscription en cours...' : '🚀 RÉCLAMER MES 20 ZAIRES MAINTENANT'}
              </button>
              <p className="security-note">🔒 Vos informations sont 100% sécurisées et confidentielles</p>
            </form>
            {message && (
              <div className={`message ${message.includes('Félicitations') ? 'success' : 'error'}`}>
                {message}
              </div>
            )}
          </div>

          <div className="social-proof-section">
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">2,500+</div>
                <div className="stat-label">Inscrits VIP</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">20 Zaires</div>
                <div className="stat-label">Bonus Garanti</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">Gratuit</div>
              </div>
            </div>
            <div className="testimonials">
              <h3>Ce Que Disent Nos VIP</h3>
              <div className="testimonial-grid">
                <div className="testimonial">
                  <p>"J'ai hâte de lancer mes produits avec ce bonus !"</p>
                  <span className="testimonial-author">- Marie K., Kinshasa</span>
                </div>
                <div className="testimonial">
                  <p>"Enfin une plateforme qui récompense les pionniers !"</p>
                  <span className="testimonial-author">- Patrick M., Lubumbashi</span>
                </div>
              </div>
            </div>
          </div>
          <div className="final-cta">
            <p className="final-cta-text">⏰ Ne laissez pas passer cette chance unique ! Les places s'envolent rapidement.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingList;